module.exports = __webpack_public_path__ + "img/main.62e9c3a9.svg";